<template>
    <van-popup v-model:show="show" round :overlay-style="{ overflow: 'hidden' }" :style="{
        width: '80%',
        Height: '50%',
        background: '#27190D',
        borderRadius: '30px'
    }">
        <van-row class="popup_head">
            <van-col span="20" offset="2" class="alignements">
                <img src="@/assets/cashwheel/cash.png" alt="">
                Receba R$ 100 de graça
            </van-col>
            <van-col span="2" class="alignements">
                <div class="close_icon alignements" @click="close">
                    <van-icon name="cross" />
                </div>
            </van-col>
        </van-row>
        <div class="pop_content">
            <div class="total_text1">SAQUE RÁPIDO</div>
            <div class="total_text">Parabéns pela sua boa sorte, você ganhou</div>
            <div class="money_amount">
                <img src="@/assets/cashwheel/pddv2_top_money.png" alt="">
                <div class="currency_text">R$</div>
                <div class="amount_text">{{ formatCurrency(animatedValue) }}</div>
            </div>
            <div class="bar_container">
                <div class="bar">
                    <div class="progress" :style="{ width: resData.user_pdd_info.current_progress / 100 + '%' }">
                    </div>
                    <div class="progress-end-value" :style="{ left: `calc(${progressPercentage}% - 45px)` }">{{
                        resData.user_pdd_info.current_progress / 100 + '%' }}</div>
                    <div class="progress-end-dot" :style="{ left: `calc(${progressPercentage}% - 30px)` }"></div>
                </div>
            </div>


            <div class="btn_container">
                <img src="@/assets/cashwheel/pddv2_pop_btn_sacar.png" alt="" @click="showSharePopup">
            </div>

            <div class="paymeny_method">
                <ReportData :dataList="assistList.rewards" reportDataHeight="115px" reportDataMargin="0"
                    colPadding="2px" currencySpanTextSize="10px" currencyTextSize="9px" :isReverse="true" />
            </div>

        </div>
    </van-popup>
    <ShareContent ref="sharePopupRef" />
</template>

<script setup lang="ts">
import { ref, defineExpose, computed } from 'vue'
import ShareContent from './shareContent.vue'
import { formatCurrency } from '@/utils/commonFunction'
import ReportData from './reportData.vue'
const show = ref(false)
const sharePopupRef = ref()
const animatedValue = ref(0)
const resData = ref()
const progressPercentage = computed(() => resData.value.user_pdd_info.current_progress / 100);

const assistList = ref({
    assists: [],
    rewards: [
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5569966036826"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5529955672359"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5537992670787"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5534939022762"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5559935934836"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5548966762018"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5529929388973"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5527998799919"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5514912448710"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5575967865248"
        },

        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5543972354561"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5548954560432"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5517935598177"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5569929029201"
        }
    ]
})

const open = (data: any) => {
    show.value = true
    resData.value = data

    const target = resData.value.user_pdd_info.current_progress / 100
    animateValue(0, target, 800)
}
const close = () => {
    show.value = false
}
const showSharePopup = () => {
    sharePopupRef.value.open()
}
const animateValue = (start: number, end: number, duration: number) => {
    const startTime = performance.now()

    const step = (currentTime: number) => {
        const progress = Math.min((currentTime - startTime) / duration, 1)
        animatedValue.value = start + (end - start) * progress

        if (progress < 1) {
            requestAnimationFrame(step)
        } else {
            animatedValue.value = end
        }
    }

    requestAnimationFrame(step)
}

defineExpose({
    open,
    close
})
</script>
<style scoped>
.popup_head {
    color: #fff;
    padding: 15px 15px 10px;
}

.popup_head img {
    width: 25px;
    padding: 0 5px;
}

.alignements {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 15px;
}

.van-overlay {
    background-color: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(8px);
}

.close_icon {
    background: rgba(0, 0, 0, 0.25);
    padding: 5px;
    border-radius: 30px;
}

.pop_content {
    border-radius: 30px;
    background: #3D2E22;
    width: 100%;
    padding-bottom: 40px;
}

.money_amount {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.money_amount img {
    width: 45px;
    padding: 0 5px;
}

.amount_text {
    font-size: 28px;
    font-weight: bold;
    color: #F0A853;
    padding: 0 10px;
}

.total_text {
    padding: 5px 25px 20px;
    color: rgba(255, 255, 255, 0.65);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 12px;
}

.total_text1 {
    padding: 20px 25px 5px;
    color: #FFF;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 13.5px;
}

.currency_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 28px;
    font-weight: bold;
}

.text1 {
    color: #fff;
    padding: 10px 25px;
    font-size: 11px;
}

.paymeny_method {
    font-family: Arial;
    font-size: 10px;
    padding: 20px 0 5px;
    background: #27190D;
    border-radius: 20px;
    margin: 0px 20px 0;
    border: 2px solid rgba(0, 0, 0, 0.25);
}

.bar_container {
    padding: 0 25px;
    position: relative;
    display: flex;
    align-items: center;
    height: 30px;
}

.bar {
    background: rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    height: 8px;
    width: 100%;
    margin: 10px 0;
}

.progress {
    background: #F0A853;
    border-radius: 10px;
    height: 8px;
}

.progress-end-value {
    position: absolute;
    top: 7.5%;
    transform: translateY(-50%);
    color: rgba(255, 255, 255, 0.65);
    padding: 2px;
    font-size: 12px;
}

.progress-end-dot {
    position: absolute;
    top: 49.75%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    background-color: white;
    border-radius: 50%;
    z-index: 2;
}

.van-steps {
    background: transparent;
}

.van-step--vertical {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.85) !important;
    padding: 5px;
}

.paymeny_method>>>.van-step__title--active {
    color: rgba(255, 255, 255, 0.85) !important;
}

.paymeny_method>>>.van-step__icon--active {
    color: #6ddf39 !important;
    background-color: #fff !important;
    border-radius: 30px;
}

.paymeny_method>>>.van-step__line {
    background-color: #3cc517 !important;
    width: 0.5px;
}

.paymeny_method>>>.van-step__icon--finish {
    color: #ffffff;
    background: #6ddf39;
    border-radius: 30px;
    font-size: 6px;
    padding: 3px
}

[class*=van-hairline]:after {
    border: none !important;
}

.btn_container {
    padding: 10px 50px;
}

.btn_container img {
    width: 100%;
}
</style>